export default __webpack_public_path__ + "static/media/FrontTalksLogo_global.126672fd.svg";